import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '../Layout'
Vue.use(VueRouter)

const routes = [
    {
      path: '/login',
      component: () => import('../views/login/index'),
      hidden: true,
      meta: { title: '登录' }
    },
  {
    path: '/retrievePassword',
    component: () => import('../views/retrievePassword/index'),
    hidden: true,
    meta: { title: '找回密码' }
  },
    {
      path: '/register',
      component: () => import('../views/register/index'),
      hidden: true,
      meta: { title: '注册' }
    },
    {
      path: '/',
      name: 'Layout',
      component: Layout,
      redirect: '/user',
      children: [
        {
          path: '/user',
          name: 'user',
          component: () => import('../views/user/index'),
          meta: { title: '会员个人中心'}
        },
        {
          path: '/editMaterials',
          name: 'editMaterials',
          component: () => import('../views/user/editData'),
          meta: { title: '会员个人中心资料编辑'}
        },
        {
          path: '/signupxi',
          name: 'signupxi',
          component: () => import('../views/signupxi/index'),
          meta: { title: '报名信息'}
        },
        {
          path: '/tidings',
          name: 'tidings',
          component: () => import('../views/tidings/index'),
          meta: { title: '我的消息'}
        },
        {
          path: '/orders',
          name: 'orders',
          component: () => import('../views/orders/index'),
          meta: { title: '缴费记录'}
        },
        {
          path: '/notice',
          name: 'notice',
          component: () => import('../views/notice/index'),
          meta: { title: '系统公告'}
        },
        {
          path: '/noticeDetails',
          name: 'noticeDetails',
          component: () => import('../views/notice/components/details'),
          meta: { title: '系统公告详情'}
        },
        {
          path: '/mySign',
          name: 'mySign',
          component: () => import('../views/mySign/index'),
          meta: { title: '我要报名'}
        },
      ]
    }
  ]


const router = new VueRouter({
  routes
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js